import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import WeinmanContent from "./WeinmanPumpContent";

class SupplierDetails extends React.Component {
  render() {
    return (
      <div className="col-lg-8 col-md-12">
        <Switch>
          <Route path="/suppliers/weinman/pumps" component={WeinmanContent} />
          <Route path="/suppliers/weinman">
            <Redirect to="/suppliers/weinman/pumps" />
          </Route>
        </Switch>
      </div>
    );
  }
}

export default SupplierDetails;
